export const content = ['live:content.part_1', 'live:content.part_2', 'live:content.part_3'];
